const selected_colors = document.querySelectorAll('.nail-picker-selected-color');
const nail_picker_updated = document.getElementById('nail-picker-updated');    
const hidden_overlay = document.getElementById('hidden-overlay');
const close_button = document.querySelector('.nail-picker-updated-close-button');
const color_items = document.querySelectorAll('.nail-picker-color');
const nail_picker_titles = document.querySelectorAll('.nail-picker-title');

const selected_colors_modal = document.querySelectorAll('.nail-picker-selected-color-modal');
const selected_colors_count = document.getElementById('nail-picker-selected-colors-count');
const nail_picker_progress_bar = document.getElementById('nail-picker-progress-bar');

const remove_selected_colors = document.querySelectorAll('.remove-selected-color');
const remove_selected_colors_modal = document.querySelectorAll('.remove-selected-color-modal');

const product_form = document.querySelector('.main-product-form');
const main_atc_button = document.getElementById('byteex-submit-button');

const atc_button_text = document.getElementById('atc-button-text');
const choose_color_button_text = document.getElementById('choose-color-button-text');

const popup_box_open = document.querySelector('.nail-picker-updated-popup-box-open');
const popup_box = document.querySelector('.nail-picker-updated-popup-box');
const popup_box_close = document.querySelector('.nail-picker-updated-popup-box-close');

// POPUP BOX
if (popup_box_open && popup_box && popup_box_close) {
  popup_box_open.addEventListener('click', () => {
    popup_box.style.display = 'block';
    close_button.style.display = 'none';
  });

  popup_box_close.addEventListener('click', () => {
    popup_box.style.display = 'none';
    close_button.style.display = 'flex';
  });
}

// COLORS FILTER
const nail_picker_filter_items = document.querySelectorAll('.nail-picker-color-filter-item');
const nail_picker_colors = document.querySelectorAll('.nail-picker-color');
nail_picker_filter_items.forEach((item, index, array) => {
  item.addEventListener('click', (event) => {
    const filter_value = event.currentTarget.dataset.value;

    item.classList.add('font-bold');
    array.forEach(i => {
      if (i !== item) {
        i.classList.remove('font-bold');
      }
    });

    nail_picker_colors.forEach(color => {
      const filters = color.dataset.filters.toLowerCase();

      if (filters.includes(filter_value) || filter_value === 'All') {
        color.classList.remove('hidden');
      } else {
        color.classList.add('hidden');
      }
    });
  });
});

// CLOSE NAIL PICKER WINDOW
function closeOnClickOutside(event) {
  if (nail_picker_updated && !nail_picker_updated.contains(event.target)) {
    hidden_overlay.style.display = 'none';
    nail_picker_updated.style.display = 'none';        
    document.body.style.overflow = 'auto';
    document.removeEventListener('click', closeOnClickOutside);
  }
}

close_button.addEventListener('click', () => {
  hidden_overlay.style.display = 'none';
  nail_picker_updated.style.display = 'none';        
  document.body.style.overflow = 'auto';
  document.removeEventListener('click', closeOnClickOutside);
});

// OPEN NAIL PICKER WINDOW
selected_colors.forEach(color => {
  color.addEventListener('click', () => {
    if (nail_picker_updated) {
      hidden_overlay.style.display = 'block';
      nail_picker_updated.style.display = 'flex';
      document.body.style.overflow = 'hidden';

      setTimeout(() => {
        document.addEventListener('click', closeOnClickOutside);
      }, 100);
    }
  });
});

if (main_atc_button) {
  main_atc_button.addEventListener('click', () => {
    const button_type = main_atc_button.type;
    if (button_type === 'button') {
      hidden_overlay.style.display = 'block';
      nail_picker_updated.style.display = 'flex';
      document.body.style.overflow = 'hidden';

      setTimeout(() => {
        document.addEventListener('click', closeOnClickOutside);
      }, 100);
    }
  });
}

// ADD COLORS TO PICKER
function getSelectedCount() {
  let count = 0;
  selected_colors.forEach(color => {
    const isSelected = color.dataset.selected;
    if (isSelected) {
      count++;
    }
  });
  return count;
}

function addColor(id, image, title) {
  for (const color of selected_colors) {
    const isSelected = color.dataset.selected;

    if (!isSelected) {
      const img = color.querySelector('img');
      img.src = image;

      const color_name = color.querySelector('p');
      color_name.textContent = title;

      const plus_icon = color.querySelector('span');
      plus_icon.style.display = 'none';

      const remove_button = color.querySelector('.remove-selected-color');
      remove_button.style.display = 'block';
      
      color.dataset.selected = true;
      color.dataset.id = id;
      break;
    }
  }

  for (const color of selected_colors_modal) {
    const isSelected = color.dataset.selected;

    if (!isSelected) {
      const img = color.querySelector('img');
      img.src = image;

      const color_plus = color.querySelector('span');
      color_plus.style.display = 'none';

      const color_name = color.querySelector('p');
      color_name.textContent = title;

      const remove_button = color.querySelector('.remove-selected-color-modal');
      remove_button.style.display = 'block';
      
      color.dataset.selected = true;
      break;
    }
  }

  const count = getSelectedCount();
  selected_colors_count.textContent = count;

  if (nail_picker_progress_bar) {
    nail_picker_progress_bar.style.width = `${(100 / colors_number) * count}%`;
  }
  
  const current_properties_block = document.getElementById('nail-picker-properties-block');

  if (count === colors_number && !current_properties_block) {
    nail_picker_titles[0].style.display = 'none';
    nail_picker_titles[1].style.display = 'block';

    atc_button_text.style.display = 'flex';
    choose_color_button_text.style.display = 'none';
    main_atc_button.type = 'submit';

    const properties_block = document.createElement('div');
    properties_block.setAttribute('id', 'nail-picker-properties-block');
    
    selected_colors.forEach((color, i) => {
      const id = color.dataset.id;

      const text_tag = color.querySelector('p');
      const title = text_tag.textContent;

      const img_tag = color.querySelector('img');
      const image = img_tag.src;

      const hiddenField1 = document.createElement('input');
      hiddenField1.setAttribute('type', "hidden");
      hiddenField1.setAttribute('class', `class${i + 1}`);
      hiddenField1.setAttribute('name', `properties[_${i + 1}.]`);
      hiddenField1.setAttribute('value', image);
      properties_block.appendChild(hiddenField1);        

      const hiddenField2 = document.createElement('input');
      hiddenField2.setAttribute('type', "hidden");
      hiddenField2.setAttribute('class', `class${i + 1}`);
      if (picker_type === 'chrome') {
        hiddenField2.setAttribute('name', `properties[Chrome ${i + 1}]`);
      } else {
        hiddenField2.setAttribute('name', `properties[Colour ${i + 1}]`);
      }
      hiddenField2.setAttribute('value', title);
      properties_block.appendChild(hiddenField2);

      const hiddenField3 = document.createElement('input');
      hiddenField3.setAttribute('type', "hidden");
      hiddenField3.setAttribute('class', `class${i + 1}`);
      hiddenField3.setAttribute('name', `properties[_id${i + 1}.]`);
      hiddenField3.setAttribute('value', id);
      properties_block.appendChild(hiddenField3);
    });

    product_form.appendChild(properties_block);

    hidden_overlay.style.display = 'none';
    nail_picker_updated.style.display = 'none';        
    document.body.style.overflow = 'auto';
    document.removeEventListener('click', closeOnClickOutside);
  }
}

color_items.forEach(color_item => {
  color_item.addEventListener('click', (event) => {
    const current_color = event.currentTarget;
    const data_id = current_color.dataset.id;
    const data_title = current_color.dataset.title;
    const data_image = current_color.dataset.image;

    addColor(data_id, data_image, data_title);
  });
});

// REMOVE COLORS FROM PICKER
function removeProperties() {
  const current_properties_block = document.getElementById('nail-picker-properties-block');

  if (current_properties_block) {
    current_properties_block.remove();

    nail_picker_titles[0].style.display = 'block';
    nail_picker_titles[1].style.display = 'none';
    
    atc_button_text.style.display = 'none';
    choose_color_button_text.style.display = 'flex';
    main_atc_button.type = 'button';
  }
}

remove_selected_colors.forEach((item, i) => {
  item.addEventListener('click', (event) => {
    event.stopPropagation();
    const current_color = event.currentTarget;
    const parent = current_color.parentElement;
    const item_number = i;

    const img = parent.querySelector('img');
    img.src = selected_color_placeholder;

    const color_name = parent.querySelector('p');
    color_name.textContent = `Colour ${i + 1}`;

    const plus_icon = parent.querySelector('span');
    plus_icon.style.display = 'block';

    const remove_button = parent.querySelector('.remove-selected-color');
    remove_button.style.display = 'none';
    
    parent.removeAttribute('data-selected');
    parent.removeAttribute('data-id');

    selected_colors_modal.forEach((color, i) => {  
      if (i === item_number) {
        const img = color.querySelector('img');
        img.src = selected_color_placeholder;

        const color_name = color.querySelector('p');
        color_name.textContent = `Colour ${i + 1}`;

        const plus_icon = color.querySelector('span');
        plus_icon.style.display = 'block';

        //const color_name = color.querySelector('p');
        //color_name.style.display = 'block';

        const remove_button = color.querySelector('.remove-selected-color-modal');
        remove_button.style.display = 'none';
        
        color.removeAttribute('data-selected');
      }
    });

    const count = getSelectedCount();
    selected_colors_count.textContent = count;

    if (nail_picker_progress_bar) {
      nail_picker_progress_bar.style.width = `${(100 / colors_number) * count}%`;
    }

    removeProperties();
  });
});

remove_selected_colors_modal.forEach((item, i) => {
  item.addEventListener('click', (event) => {
    const current_color = event.currentTarget; 
    const parent = current_color.parentElement;
    const item_number = i;

    const img = parent.querySelector('img');
    img.src = selected_color_placeholder;

    const color_plus = parent.querySelector('span');
    color_plus.style.display = 'block';

    const color_name = parent.querySelector('p');
    color_name.textContent = `Colour ${i + 1}`;

    const remove_button = parent.querySelector('.remove-selected-color-modal');
    remove_button.style.display = 'none';
    
    parent.removeAttribute('data-selected');

    selected_colors.forEach((color, i) => {  
      if (i === item_number) {
        const img = color.querySelector('img');
        img.src = selected_color_placeholder;

        const color_name = color.querySelector('p');
        color_name.textContent = `Colour ${i + 1}`;

        const plus_icon = color.querySelector('span');
        plus_icon.style.display = 'block';

        const remove_button = color.querySelector('.remove-selected-color');
        remove_button.style.display = 'none';
        
        color.removeAttribute('data-selected');
        color.removeAttribute('data-id');
      }
    });

    const count = getSelectedCount();
    selected_colors_count.textContent = count;

    if (nail_picker_progress_bar) {
      nail_picker_progress_bar.style.width = `${(100 / colors_number) * count}%`;
    }

    removeProperties();
  });
});

// CLEAR NAIL PICKER AFTER ADDING PRODUCT TO CART - working in cart drawer
window.clearNailPickerUpdated = function() {
  selected_colors.forEach((item, i) => {
    const img = item.querySelector('img');
    img.src = selected_color_placeholder;

    const color_name = item.querySelector('p');
    color_name.textContent = `Colour ${i + 1}`;

    const plus_icon = item.querySelector('span');
    plus_icon.style.display = 'block';

    const remove_button = item.querySelector('.remove-selected-color');
    remove_button.style.display = 'none';
    
    item.removeAttribute('data-selected');
    item.removeAttribute('data-id');
  });

  selected_colors_modal.forEach((item, i) => {
    const img = item.querySelector('img');
    img.src = selected_color_placeholder;

    const color_plus = item.querySelector('span');
    color_plus.style.display = 'block';

    const color_name = item.querySelector('p');
    color_name.textContent = `Colour ${i + 1}`;

    const remove_button = item.querySelector('.remove-selected-color-modal');
    remove_button.style.display = 'none';
    
    item.removeAttribute('data-selected');
  });

  selected_colors_count.textContent = 0;

  removeProperties();

  if (nail_picker_progress_bar) {
    nail_picker_progress_bar.style.width = 0;
  }
}
